 <template>
 <div v-role="'func'">
         <v-progress-linear  style="margin : 0 auto ; height:10px" :indeterminate="isLoading" v-show="isLoading"></v-progress-linear>

   <div>
  <v-data-table
    :headers="headers"
    :items="instituicoes"

    :sort-desc="true"

    class="elevation-1"
    :search="search"
  >
    <template v-slot:top>
      <v-toolbar flat color="white">

        <v-toolbar-title class="hidden-sm-and-down">
          Instituições

        </v-toolbar-title>

        <v-divider class="mx-8  hidden-sm-and-down" inset vertical></v-divider>

        <!--  search  -->
        <div v-if="$store.state.hasMessage" :class="$store.state.classMessage">
          {{ $store.state.textMessage }}
        </div>

        <div class="flex-grow-1"></div>

        <v-text-field
          v-model="search"
          append-icon="search"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
        <!-- end  search  -->

        <v-divider class="mx-4 hidden-sm-and-down" inset vertical></v-divider>
 <v-btn  v-if="search"  @click="initInstituicoes(search)" text icon color="green">
              <v-icon>cached</v-icon>
            </v-btn>

        <v-spacer></v-spacer>
        <v-dialog v-model="dialog" max-width="800px">

          <template v-slot:activator="{ on }">
            <v-btn class="mx-2" fab dark color="primary" v-on="on">
              <v-icon dark>add</v-icon>
            </v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="headline">Actualizar dados da Instituição </span>

            </v-card-title>

            <v-card-text>
              <v-container>
                <v-form ref="form" v-model="formValid" lazy-validation>
                  <v-row>
                    <v-col cols="12" sm="12" md="12">
                      <div
                        v-if="$store.state.hasMessage"
                        :class="$store.state.classMessage"
                      >
                        {{ $store.state.textMessage }}
                      </div>

                    </v-col>
                    <v-col v-if="false" cols="12" sm="12" md="6">
                      <v-text-field

                        v-model="editedItem.idFuncionario"
                        label="cod"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" sm="12" md="6">
                       <v-text-field
                           label="Instituição"
                           v-model="editedItem.descricao"
                           :rules="rules"
                     ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="6">
                       <v-text-field
                       label="Sigla"
                       v-model="editedItem.sigla"
                       :rules="rules_sigla"
                     ></v-text-field>
                    </v-col>
                  </v-row>
                </v-form>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-row>
                   <v-col md="10"></v-col>
                   <v-col md="2">
                      <v-progress-circular v-if="progresso"
                    :size="50"
                    color="green"
                    indeterminate
                  ></v-progress-circular>
                   </v-col>
                </v-row>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
              <v-btn
                color="blue darken-1"
                :disabled="
                  !(formValid)
                "
                text
                @click="save"
                >Save</v-btn
              >

            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>
    <template v-slot:item.action="{ item }">
      <v-icon small class="mr-2" @click="editItem(item)">edit</v-icon>
     </template>
    <template v-slot:no-data>
      no data
    </template>
  </v-data-table>
 </div>
 </div>
</template>
<script>
import axios from '../../plugins/axios'
// const ls = require('local-storage')
export default {
  data: () => ({
    replace: false,
    disciplinas: [],
    instituicoes: [],
    disciplinasFiltered: [],
    professordiscijaexiste: [],
    text: '',
    flag_curso: '',
    formValid: true,
    isLoading: false,
    progresso: false,
    turmasAll: [],
    turmasFiltered: [],
    search: '',
    cursos: [],
    rules: [
      value => !!value || 'Required.',
      value => (value && value.length >= 6) || 'Min 6 caracteres'
    ],
    rules_sigla: [
      value => !!value || 'Required.',
      value => (value && value.length >= 3) || 'Min 3 caracteres'
    ],
    professores: [],
    profediscinas: [],
    dialog: false,
    headers: [

      { text: 'Instituição', value: 'descricao' },
      { text: 'Sigla', value: 'sigla' },

      { text: 'Actions', value: 'action', sortable: false }
    ],

    editedIndex: -1,
    editedItem: {
      idInstituicao: 0,
      descricao: '',
      sigla: ''

    },
    defaultItem: {
      idProfessorDisciTurma: 0,
      curso: 0,
      iddisciplina: 0,
      professor: 0,
      turma: 0,
      desciplinaDescricao: ''
    }
  }),

  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'Atribuir Disciplina ao Professor' : 'Editar'
    }

  },

  watch: {
    dialog (val) {
      val || this.close()
    }
  },

  created () {
    // check if classe has been selected otherwise send back to painel to select
    this.initInstituicoes()
  },

  methods: {

    async initInstituicoes (search) {
      try {
        let payload = { 'find': 'all' }
        this.isLoading = true
        if (!search) {
          payload = { 'find': 'all' }
        } else {
          payload = { 'find': search }
        }
        this.instituicoes = await axios
          .post('/listarInstituicao-pesquisa/', payload)
          .then(res => res.data)
        this.isLoading = false
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', {
          msg: this.text,
          classMessage: 'msgError',
          timeout: 3000
        })
      }
    },
    editItem (item) {
      this.editedIndex = this.profediscinas.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },

    deleteItem (item) {
      const index = this.profediscinas.indexOf(item)
      confirm('Are you sure you want to delete this item?') &&
        this.profediscinas.splice(index, 1)
    },

    close () {
      this.replace = false
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },

    async  save () {
      let params =
       {
         idInstituicao: this.editedItem.idInstituicao,
         descricao: this.editedItem.descricao,
         sigla: this.editedItem.sigla
       }

      try {
        this.progresso = true
        let cor_mensagem = 'msgSucess'
        let msg = await axios
          .post('/Actualizar-Instituicao', params)
          .then(res => res.data)
        this.progresso = false

        if (msg.length) {
          cor_mensagem = 'msgError'
          this.text = 'Erro ao tentar efectuar a operação'
        } else {
          cor_mensagem = 'msgSucess'
          this.text = 'Operação efectuada com sucesso'
          this.instituicoes = this.instituicoes.filter(p => p.idInstituicao !== this.editedItem.idInstituicao)
          this.instituicoes.unshift(params)
          this.dialog = false
        }

        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': cor_mensagem, 'timeout': 3000 })
      } catch (error) {
        this.progresso = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    }
  }
}
</script>
